import { axios } from '@/utils/request'

const api = {
  wexameList: '/adminapi/wexame/exameList',
  wexameAdd: '/adminapi/wexame/exameAdd',
  wexameEdit: '/adminapi/wexame/exameEdit',
  wexameDelete: '/adminapi/wexame/exameDelete',
  wexameDetail: '/adminapi/wexame/exameDetail',
  logList: '/adminapi/wexame/logList',
  getExameOptions: '/adminapi/wexame/exameOptions',
}

export default api

export function getExameList(parameter) {
  return axios({
    url: api.wexameList,
    method: 'get',
    params: parameter
  })
}
export function getLogList(parameter) {
  return axios({
    url: api.logList,
    method: 'get',
    params: parameter
  })
}
export function getExameDetail(parameter) {
  return axios({
    url: api.wexameDetail,
    method: 'get',
    params: parameter
  })
}
export function addExame(parameter) {
  return axios({
    url: api.wexameAdd,
    method: 'post',
    data: parameter
  })
}
export function editExame(parameter) {
  return axios({
    url: api.wexameEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteExame(parameter) {
  return axios({
    url: api.wexameDelete,
    method: 'post',
    data: parameter
  })
}
export function getExameOptions(parameter) {
  return axios({
    url: api.getExameOptions,
    method: 'post',
    data: parameter
  })
}